var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEricssonBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2067_50748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0747 10.2086L17.6964 15.9917C16.0482 16.5411 15.1519 18.3339 15.7012 19.9821C16.2506 21.6303 18.0434 22.5266 19.6916 21.9772L37.0699 16.1941C38.7181 15.6447 39.6145 13.8519 39.0651 12.2038C38.5157 10.5556 36.7229 9.65917 35.0747 10.2086Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0747 0.173416L17.6964 5.95655C16.0482 6.50595 15.1519 8.29872 15.7012 9.94691C16.2506 11.5951 18.0434 12.4915 19.6916 11.9421L37.0699 6.15896C38.7181 5.60956 39.6145 3.81679 39.0651 2.1686C38.5157 0.520404 36.7229 -0.375982 35.0747 0.173416Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0748 20.2398L17.6676 26.023C16.0194 26.5724 15.123 28.3651 15.6724 30.0133C16.2218 31.6615 18.0146 32.5579 19.6628 32.0085L37.0411 26.2254C38.6893 25.676 39.5857 23.8832 39.0363 22.235C38.5158 20.5868 36.723 19.6904 35.0748 20.2398Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11084 44.7328H5.81205V43.0557H2.11084V41.6388H5.95663V40.0195H0V47.8268H6.01446V46.1786H2.11084V44.7328Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3491 40.0195H15.2383V47.8268H17.3491V40.0195Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.559 43.8651C20.6168 41.2627 23.2192 40.9446 24.9542 41.9277L25.0987 40.2506C22.1204 39.1229 18.3903 40.135 18.3903 43.8362C18.3614 47.6241 22.0626 48.6073 25.1277 47.6241L25.012 45.9181C23.2771 46.8434 20.5301 46.4675 20.559 43.8651Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1062 42.073C28.1062 41.1477 30.1303 41.1767 31.2002 41.755L31.3447 40.1357C28.7712 39.355 25.9375 39.9622 25.9375 42.2465C25.9375 45.0224 29.5809 44.3285 29.5809 45.5718C29.5809 46.6996 27.5857 46.555 26.1977 45.9188L26.0532 47.6538C28.2797 48.3188 31.7206 48.2899 31.7206 45.3984C31.7206 42.4779 28.1062 43.461 28.1062 42.073Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5251 42.073C34.5251 41.1477 36.5492 41.1767 37.6191 41.755L37.7637 40.1357C35.1902 39.355 32.3564 39.9622 32.3564 42.2465C32.3564 45.0224 35.9998 44.3285 35.9998 45.5718C35.9998 46.6996 34.0046 46.555 32.6167 45.9188L32.4432 47.6538C34.6697 48.3188 38.1396 48.2899 38.1396 45.3984C38.1396 42.4779 34.5251 43.461 34.5251 42.073Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8003 40.0195V45.0509L50.2268 40.0195H47.5376V47.8268H49.5039V42.6798L52.193 47.8268H54.7376V40.0195H52.8003Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6218 39.8164C40.4242 39.8164 38.7471 41.1176 38.7471 43.9224C38.7471 46.6405 40.4242 47.9995 42.6218 47.9995C44.8194 47.9995 46.4965 46.6116 46.4965 43.9224C46.5254 41.1176 44.8483 39.8164 42.6218 39.8164ZM42.6218 46.467C41.4362 46.467 40.9157 45.108 40.9157 43.9224C40.9157 42.7369 41.4362 41.3779 42.6218 41.3779C43.8073 41.3779 44.3278 42.8236 44.3278 43.9224C44.3278 45.108 43.8362 46.467 42.6218 46.467Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4626 43.981C13.359 43.7207 13.8217 43.1424 13.8217 42.1015C13.8217 40.4822 12.3759 40.0195 11.3349 40.0195H7.51807V47.8268H9.59999V44.8774C9.59999 44.8484 10.1205 44.8774 10.4385 44.8774C10.8145 44.8774 11.0747 45.1087 11.2193 45.4846L12.0289 47.8268H14.2843C14.2843 47.8268 13.1855 44.7906 13.1855 44.7617C12.9542 44.1834 12.4916 43.981 12.4626 43.981ZM10.6988 43.287H9.54216V41.5521H10.7277C11.2771 41.5521 11.6819 41.8991 11.6819 42.4195C11.7108 42.9978 11.2193 43.3159 10.6988 43.287Z",
    fill: "#6A6F73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2067_50748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.7374,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEricssonBrand);
export default __webpack_public_path__ + "static/media/ericsson-brand.1958ed194731edb440aebb0a04d34c73.svg";
export { ForwardRef as ReactComponent };